<template>
  <div
    style="width: 100%; height: 100%"
    ref="chartsDom"
    class="chartsDom"
  ></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chartsDom",
  props: {
    list: Object,
  },
  data() {
    return {
      goToSchoolTwo: {},
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.goToSchoolTwo = newVal;
        if (true) {
          this.$nextTick(() => {
            this.initNYNM();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.goToSchoolTwo = this.list;
    this.$nextTick(() => {
      this.initNYNM();
    });
    window.addEventListener("resize", () => {
      this.$echarts.init(this.$refs.chartsDom).resize();
    });
  },
  methods: {
    initNYNM() {
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表

      let myChart = this.$echarts.init(this.$refs.chartsDom);
      // 2. 指定配置和数据

      let goToSchoolTwo = this.goToSchoolTwo;
      // console.log(goToSchoolTwo, 'goToSchoolTwo')

      let legendColor = [
        "#24EACD",
        "#FFFA92",
        "#13E7FF",
        "#FF0009",
        "#00B5FF",
        "#FAEAA1",
        "#3AA2E8",
        "#5fc6fc",
      ];

      let option = {
        title: [
          {
            text: goToSchoolTwo.value + "%",
            left: "48%",
            y: "38%",
            textAlign: "center",
            textStyle: {
              fontSize: "23",
              fontWeight: "100",
              color: goToSchoolTwo.color,
              textAlign: "center",
              // fontFamily: "serif"
              fontFamily: "Impact",
            },
          },
        ],
        polar: {
          radius: ["62%", "50%"],
          center: ["50%", "50%"],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            roundCap: true,
            barWidth: 60,
            showBackground: false,
            backgroundStyle: {
              color: "#2e2856",
            },
            data: [goToSchoolTwo.value],
            coordinateSystem: "polar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: goToSchoolTwo.color,
                  },
                  {
                    offset: 1,
                    color: goToSchoolTwo.color,
                  },
                ]),
              },
            },
          },
          {},
        ],
      };

      /*  */

      // 3. 把配置给实例对象
      myChart.setOption(option);
      // 4. 让图表跟随屏幕自动的去适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>
